var _effectorFileName = "/src/page-content/payment-rules/model.ts";
import { pagesPath } from '@/shared/config/$path';
import { declarePage } from '@/shared/lib/effector/page';
export const paymentRulesPage = declarePage({
  pageType: pagesPath.$url().pathname
});